// extracted by mini-css-extract-plugin
export default {"sun":"Sun_sun__iFY8K","rotateSun":"Sun_rotateSun__R0wqs"};